import {  get } from "../../service/api";

const GetSettleTransaction = async (merchantId,merchantSettleId) => {
    try {
        const response = await get(`/merchant/${merchantId}/merchantSettle/${merchantSettleId}/transaction`);
        return response;
    } catch (error) {
        console.error('Error GetSettleTransaction:', error);
        throw error;
    }
};

export default GetSettleTransaction;